import { useState } from 'react';
import { Check, ChevronsUpDown } from 'lucide-react';
import { cn } from '@/lib/utils';
import { Button } from '@/components/ui/button';
import {
  CommandInput,
  CommandList,
  CommandEmpty,
  CommandGroup,
  CommandItem,
  Command,
} from '@/components/ui/command';
import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from '@/components/ui/popover';
import { Label } from '@/components/ui/label';

function SelectWithSearch({
  list,
  value,
  setValue,
  id,
  label,
  fallbackSearchText,
  emptySearchFallbackText,
}: {
  list?: Record<string, string>[] | null;
  value: string;
  setValue: (value: string) => void;
  id?: string;
  label: string;
  fallbackSearchText: string;
  emptySearchFallbackText: string;
}) {
  const [open, setOpen] = useState(false);

  if (!list) {
    return;
  }

  return (
    <div className='flex w-full flex-col' id={id}>
      <Label htmlFor={id} className='mb-1'>
        {label}
      </Label>
      <Popover open={open} onOpenChange={setOpen} modal>
        <PopoverTrigger asChild>
          <Button
            variant='outline'
            role='combobox'
            aria-expanded={open}
            className='items-center w-full [&>span]:flex [&>span]:justify-between [&>span]:w-full'
          >
            {value
              ? list.find((item) => item.value === value)?.value
              : fallbackSearchText}
            <ChevronsUpDown className='opacity-50' size={16} />
          </Button>
        </PopoverTrigger>
        <PopoverContent className='p-0'>
          <Command>
            <CommandInput placeholder='Search market' className='h-9' />
            <CommandList>
              <CommandEmpty>{emptySearchFallbackText}</CommandEmpty>
              <CommandGroup>
                {list.map((item) => (
                  <CommandItem
                    key={item.value}
                    value={item.value}
                    onSelect={(currentValue) => {
                      setValue(currentValue === value ? '' : currentValue);
                      setOpen(false);
                    }}
                  >
                    {item.label}
                    <Check
                      className={cn(
                        'ml-auto',
                        value === item.value ? 'opacity-100' : 'opacity-0',
                      )}
                    />
                  </CommandItem>
                ))}
              </CommandGroup>
            </CommandList>
          </Command>
        </PopoverContent>
      </Popover>
    </div>
  );
}

export default SelectWithSearch;
